import './App.css';
// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ReviewForm from "./Components/ReviewForm";
import AdminLogin from "./Components/AdminLogin";
import Admin from "./Components/Admin";
import PrivateRoute from "./Components/PrivateRoute"; 
import Month from "./Components/Month";
import ThankYou from "./Components/ThankYou";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<ReviewForm />} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/month" element={<Month />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route
          path="/admin"
          element={
            <PrivateRoute>
              <Admin />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;



